// Training Sessions List Page — wrapper AppLayout autour du contenu réutilisable
import React from 'react';
import { AppLayout } from '@/components/layout/AppLayout';
import TrainingSessionsContent from './TrainingSessionsContent';

export default function TrainingSessionsPage() {
  return (
    <AppLayout>
      <TrainingSessionsContent />
    </AppLayout>
  );
}
